"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
/**
 * Validates an entity using the data model schemas, throwing an error when
 * validation fails.
 */
function validateEntityWithSchema(entity) {
    for (const c of entity._class) {
        const validate = _1.IntegrationSchema.getSchema(`#${c}`);
        if (!validate) {
            throw new Error(`Could not find schema for class ${c}!`);
        }
        if (!validate(entity)) {
            throw new Error(`Entity fails to validate as class '${c}':\n\n${JSON.stringify(validate.errors, null, 2)}`);
        }
    }
}
exports.validateEntityWithSchema = validateEntityWithSchema;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGVFbnRpdHlXaXRoU2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3ZhbGlkYXRlRW50aXR5V2l0aFNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHdCQUFzQztBQUV0Qzs7O0dBR0c7QUFDSCxTQUFnQix3QkFBd0IsQ0FBQyxNQUE0QjtJQUNuRSxLQUFLLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxNQUFNLEVBQUU7UUFDN0IsTUFBTSxRQUFRLEdBQUcsb0JBQWlCLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUN0RCxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ2IsTUFBTSxJQUFJLEtBQUssQ0FBQyxtQ0FBbUMsQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUMxRDtRQUVELElBQUksQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLEVBQUU7WUFDckIsTUFBTSxJQUFJLEtBQUssQ0FDYixzQ0FBc0MsQ0FBQyxTQUFTLElBQUksQ0FBQyxTQUFTLENBQzVELFFBQVEsQ0FBQyxNQUFNLEVBQ2YsSUFBSSxFQUNKLENBQUMsQ0FDRixFQUFFLENBQ0osQ0FBQztTQUNIO0tBQ0Y7QUFDSCxDQUFDO0FBakJELDREQWlCQyJ9